module.exports = __webpack_public_path__ + "media/images/map-marker-c8eecbf7907e4fdd222109b0d62d4555.svg";